import axios from 'axios';
import { getToken, clearAuthData } from './auth';

// Create axios instance with default config
const api = axios.create({
  baseURL: 'https://serv.stjg.rakopssolutions.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for API calls
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for API calls
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Clear auth data and redirect to login
      clearAuthData();
      window.location.href = '/?session_expired=true';
    }
    return Promise.reject(error);
  }
);

export default api;